import { InfoTooltip } from '../../../../../../components/InfoTooltip';
import classNames from 'classnames';
import styles from '../styles.module.scss';
import React from 'react';

function TooltipBulletPoint(text: string | JSX.Element, index: number) {
  return (
    <div className='d-flex' key={index}>
      <span
        className={classNames(
          'me-2 bg-white',
          styles['tooltip-custom-bullet-point'],
        )}
      />
      <div>{text}</div>
    </div>
  );
}

export function AdvancedSearchTooltip() {
  const bulletPointMessages = [
    'Use AND or OR to include or exclude specific terms from your search',
    <>
      Use field prefixes for targeted search: <b>name:</b>, <b>email:</b>,{' '}
      <b>location:</b>, <b>job:</b> or <b>cv:</b>
    </>,
    'Example: name:John AND job:engineer',
  ];
  return (
    <InfoTooltip>
      {bulletPointMessages.map((message, index) =>
        TooltipBulletPoint(message, index),
      )}
    </InfoTooltip>
  );
}
